import { render } from "./InstanceSummary.vue?vue&type=template&id=47dc7088&scoped=true"
import script from "./InstanceSummary.vue?vue&type=script&lang=js"
export * from "./InstanceSummary.vue?vue&type=script&lang=js"

import "./InstanceSummary.vue?vue&type=style&index=0&id=47dc7088&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47dc7088"

export default script